import React from "react";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <>
      <section className="error-page section">
        <div className="error-container">
          <h2>You are at wrong place. please go back</h2>
          <Link to="/" className="btn tn-primary">
            Back Home
          </Link>
        </div>
      </section>
    </>
  );
};

export default Error;
